import { createMainPageRoutes } from '@completeanatomy/main-screen';

export const mainPageRoutes = createMainPageRoutes();

// Hack to change the path of the first route. Should be moved to the main-screen package
if (!process.env.REACT_APP_KC_TOKEN && mainPageRoutes.children.length > 0) {
  mainPageRoutes.children.push({
    ...mainPageRoutes.children[0],
    path: '/screens/:id/:name',
  });
}
